import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    headerSortingClasses,
} from "../../../../_metronic/_helpers";
import { useSubheader } from "../../../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, baseURL } from "../../../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { temp_store } from "../../../modules/function/temp_store"
import { useIntl } from "react-intl";

export const EditNewsImage = (props) => {
    const intl = useIntl();

    const suhbeader = useSubheader();
    const allData = [];
    const [templateData, setTemplateData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalSize, setTotalSize] = useState(100);
    const [is_loading, setIs_Loading] = useState(false);
    const [listError, setlistError] = useState(false);
    suhbeader.setTitle("Edit News Image");
    const { user } = useSelector((state) => state.auth);
    const [listMasterModel, setListMasterModel] = useState([]);
    const history = useHistory();
    const [id, setID] = useState();

    useEffect(() => {
        console.log('check')
        getListMasterModel(page, limit, temp_store(props).location.state.row.id);
        console.log('check')

    }, []);

    /*const getListMasterModel = async (page, limit) => {

        try {
            console.log(props.location.state.row)
            let Tempdata = []
            props.location.state.row.kms_news_bannerimages.map(data => {
                console.log(data.id, data.is_delete)
                if (!data.is_delete) {
                    Tempdata.push({
                        news_id: data.news_id,
                        image_path: data.image_path
                    })
                }
                // props.location.state.row.kms_news_bannerimages
            })
            console.log(Tempdata)
            setListMasterModel(Tempdata)
        } catch {
            setListMasterModel([])
        }

    };*/

    const getListMasterModel = async (page, limit, id) => {
        setIs_Loading(true);
        const apiUrls = `${baseURLV1}/news/image/${id}/?page=${page}&limit=${limit}`; // รอแก้
        axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${user.data.access_token}`,
            },
        })
            .then((res) => {
                setListMasterModel(res.data.data);
                setIs_Loading(false);
                setlistError(false);

                var totalpage = Math.ceil(res.data.total / res.data.limit);
                setTotalPage(totalpage);
                setTotalSize(res.data.total);
                setLimit(res.data.limit);
                setTemplateData(allData);
            })
            .catch((err) => {
                if (err.response) {
                    setIs_Loading(false);
                    setlistError(true);
                }
            });
    };


    const columns = [

        {
            dataField: "news_id",
            text: "News id",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },

        /* {
             dataField: "image_path",
             text: "Image path",
             sort: true,
             sortCaret: sortCaret,
             headerSortingClasses,
         },*/
        {
            text: "Image",
            dataField: "image_path",
            formatter: (img, row, rowIndex) => {
                return (
                    <div>
                        <img
                            style={{
                                width: "120px",
                                height: "100px",
                            }}
                            src={row.image_path}
                        />
                    </div>
                );
            },
        },
        {
            text: "Action",
            dataField: "id",
            formatter: (id, row, rowIndex) => {
                return (
                    <div>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => deleteItem({ row, rowIndex })}
                        >
                            Delete
                        </button>
                    </div>
                );
            },
        },
    ];

    const deleteItem = (data) => {
        console.log(data)
        Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover this limit point !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.value) {
                axios
                    .delete(`${baseURLV1}/news/image/${data.row.id}`)
                    .then((res) => {
                        Swal.fire("Deleted!", "Your model has been deleted.", "success");
                        getListMasterModel(page, limit, data.row.news_id);
                    })
                    .catch((err) => {
                        Swal.fire(
                            "Deleted!",
                            "Your model has been fail to deleted.",
                            "error"
                        );
                    });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelled", "Your model is safe :)", "error");
            }
        });
    };
    const [search, setSearch] = useState();
    const handleSearch = () => {
        setPage(1);
        getListMasterModel(1, limit, search);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        getListMasterModel(value, limit);
    };

    const handlePageSizeChange = (event) => {
        setLimit(event.target.value);
        getListMasterModel(1, event.target.value);
    };

    const editItem = (data) => {
        history.push("/CreateNewsImage", data);
    };

    return (
        <Card>
            <CardHeader title="Edit News Image">

                <CardHeaderToolbar>
                    <Link to="/CreateNewsImage">
                        <button type="button" className="btn btn-primary">
                            + Create
                        </button>
                    </Link>

                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Link to="/NewsManagement">
                    <button type="button" className="btn btn-secondary wbt mr-5">
                        {intl.formatMessage({ id: "104047", defaultMessage: "Back" })}
                    </button>
                </Link>


                {/* /Search Btn/ */}

                {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}


                <BootstrapTable
                    keyField="id"
                    data={listMasterModel}
                    columns={columns}
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                />
                <div className=" col-lg-12">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mt-3">
                                {"Items per Page: "}
                                <select onChange={handlePageSizeChange} value={limit}>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <Pagination2
                                className="mt-3 "
                                count={totalPage}
                                page={page}
                                siblingCount={1}
                                boundaryCount={1}
                                variant="outlined"
                                shape="rounded"
                                onChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>

            </CardBody>
        </Card>
    );
};
